module.exports = __webpack_public_path__ + "static/media/DesktopBG.c5aaf92a.mp4";